import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input() showFull = true;
  @Input() isLogin = false;
  appVersion = `${environment.prefixVersion}${environment.version} - ${environment.name}`;
  footers = [
    { link: '#', label: 'Privacy Policy', value: 'PP' },
    { link: '#', label: 'Terms of Service', value: 'TOF' },
    { link: '#', label: 'Contact Us', value: 'CU' },
  ];

  constructor(
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  goToFaq() {
    window.open('https://logchain.tawk.help/', '_blank')
  }

  actionFooter(value: string) {
    if(value === 'PP') {
      // this.dialog.open(PrivacyPolicyComponent, { panelClass: 'customise-dialog' })
      window.open('https://thelogchain.com/privacy-policy', '_blank')
    }
    if(value === 'CU') {
      window.open('https://thelogchain.com/contact-logchain/', '_blank')
    }
  }

}
